import { configureStore } from '@reduxjs/toolkit'
import userReducer from '../slices/user'
import waitlistReducer from '../slices/waitlist'
import tutorReducer from '../slices/tutor'
import searchTutor from '../slices/search'
import admin from '../slices/admin'
import request from '../slices/request'
import studnent from '../slices/studnent'
import earlyAcessRedcuer from '../slices/earylyAccess'
import session from '../slices/session'
import quizReducer from '../slices/quiz'
import flashcardReducer from '../slices/flashcard'
import quizAttemptReducer from '../slices/quizAttempt'
import flashcardProgressReducer from '../slices/flashcardProgress'
import progressReducer from '../slices/progress'

export const store = configureStore({
    reducer: {
        waitlist: waitlistReducer,
        user: userReducer,
        tutor: tutorReducer,
        search: searchTutor,
        admin: admin,
        request: request,
        student: studnent,
        earlyAccess:earlyAcessRedcuer,
        session:session,
        quiz: quizReducer,
        flashcard: flashcardReducer,
        quizAttempt: quizAttemptReducer,
        flashcardProgress: flashcardProgressReducer,
        progress: progressReducer
    }
})

export default store